import React, { useEffect, useState } from "react";
import AdminLayout from "../layouts/AdminLayout";

function ManageAdmins() {
  const [admins, setAdmins] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ email: "", role: "admin", permissions: {} });

  useEffect(() => {
    fetch("https://kolibusiness.com/backend/get-admin-users.php")
      .then(res => res.json())
      .then(setAdmins);
  }, []);

  const handleSave = async () => {
    const res = await fetch("https://kolibusiness.com/backend/save-admin-user.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      alert("Admin saved");
      setEditingId(null);
    }
  };

  const handlePermissionToggle = (key) => {
    setForm({
      ...form,
      permissions: {
        ...form.permissions,
        [key]: {
          ...form.permissions[key],
          enabled: !form.permissions[key]?.enabled,
        },
      },
    });
  };

  return (
    <AdminLayout>
      <h2>Manage Admins</h2>
      <input
        type="email"
        placeholder="Admin Email"
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
      />
      <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
        <option value="admin">Admin</option>
        <option value="superadmin">Superadmin</option>
      </select>

      <h4>Permissions</h4>
      {["dashboard", "add_product", "view_products", "banners"].map((perm) => (
        <div key={perm}>
          <label>
            <input
              type="checkbox"
              checked={form.permissions[perm]?.enabled || false}
              onChange={() => handlePermissionToggle(perm)}
            />
            {perm.replace(/_/g, " ")}
          </label>
        </div>
      ))}

      <button onClick={handleSave}>Save Admin</button>

      <h3>Existing Admins</h3>
      <ul>
        {admins.map((admin) => (
          <li key={admin.id}>{admin.email} — {admin.role}</li>
        ))}
      </ul>
    </AdminLayout>
  );
}

export default ManageAdmins;
